window.matchMedia =
  window.matchMedia ||
  (() => ({
    matches: false,
    addListener: () => {},
    removeListener: () => {},
  }));

export const isMobile = window.matchMedia('(max-device-width: 1224px)').matches;
export const isLandscape = window.matchMedia('(orientation: landscape)').matches;
export const isDesktop = window.matchMedia('(min-device-width: 1224px)').matches;
export const isOnlyMobile = window.matchMedia('(max-device-width: 768px)').matches;
